import Config from "../../config";
import { UserModel, UserStatus } from "../../models/users.model";
import { AppState } from "../../reducers/models";
import { UtilityService } from "../../services/UtilityService";
import store from "../../stores/app-store";
import { ImportReportResponse } from "./schedule-messages.model";

export class ConversationModel {
    constructor() {
    }

    ID: string;
    SequenceId?: string;
    IsArchived: boolean;
    IsOutbound: boolean;
    FromPhoneNumber?: string;
    PhoneNumber: string;
    MaskedPhoneNumber: string;
    Media?: MediaModel[];
    Message: string | null;
    MessageDateTime: string;
    SenderID: string;
    UnReadCount: number;
    Contact?: Contact;
    IsPinned: boolean;
    IsBlocked: boolean;
    IsUnsubscribed: boolean;
    DeliveryStatus: DeliveryStatus;
    IsMuted: boolean;
    GroupChat?: GroupChatModel;
    GroupChatId?: string
    Campaign?: CampaignModel
    CampaignId?: string
    ConversationAuditId?: string;
    msgType?: string;
    RecipientStatusList?: RecipientStatusList[];
    Type?: Type;
    BundleId?: string;
    IsOptInCollected?: boolean;
    AssignStatus?: StatusEnum;
    Assignee?: string

}

export enum Type {
    Normal,
    Alert,
    Title,
    Context,
    Transfer,
    AssignStatus,
    TeamNote,
}

export interface RecipientStatusList {
    PhoneNumber: string,
    Status: number
}

export enum DeliveryStatus {
    NONE, PENDING, SENT, FAILED, RECEIVED, SENDING, READ, PARTIALLYSENT
}

export interface ContactCustomAttribute {
    id: string;
    reference: string;
    name: string;
    value: string;
    type?: number;
}


export class Contact {
    constructor() {
    }

    ID: string;
    Email: string;
    FirstName: string;
    LastName: string;
    Name: string;
    PhoneNumber: string;
    MaskedPhoneNumber: string;
    Groups?: Group[];
    IsBlocked: boolean;
    IsUnsubscribed: boolean;
    IsDeleted: boolean;
    IsPublic: boolean;
    IsPinned: boolean;
    UnReadCount: number;
    CreatedDateTime: string;
    Errors?: ContactError;
    ContactStatus: ContactStatus
    Source: string;
    AssignedToId: string;
    Status: number;
    CreatedById: string;
    UpdatedById: string
    IsOptInCollected?: boolean;
    CustomAttributes?: ContactCustomAttribute[];
}

export enum ContactStatus {
    ACTIVE = 1,
    BLOCKED,
    UNSUBSCRIBED,
}

export class ContactError {
    constructor() {
    }
    FirstName: string;
    ContactLastName: string;
    PhoneNumber: string;
    ContactEmail: string
}

export class Group {
    constructor() {
    }

    ID: string;
    Name: string;
    CreatedDateTime: string;
    ContactsCount: number;
    TotalActiveContacts: number;
    TotalBlockedContacts: number;
    TotalUnsubscribedContacts: number;
    Contacts?: Contact[];
    IsDeleted?: boolean;
}

export class ContactType {
    IsPinned: boolean;
    IsArchived: boolean;
    CreatedDateTime: string;
    MutedTill: string;
    PhoneNumber: string;
}

export class MediaModel {
    constructor() {
    }

    ID: string;
    Name: string;
    Url: string;
    ContentType: string;
}

export class GroupChatModel {
    ID: string;
    PhoneNumbers: string[];
    Name: string;
    UnReadCount: number;
}
export class CampaignModel {
    ID: string;
    ToPhoneNumbers: string[];
    Name: string;
    CreatedDateTime?: string;
    CreatedById?: string
}



export const mapToGroupChat = (groupchat: any): GroupChatModel => {
    return {
        ID: groupchat.id,
        PhoneNumbers: groupchat.phoneNumbers,
        Name: groupchat.name,
        UnReadCount: groupchat.unReadCount,
    } as GroupChatModel;
};

export class DeletedGroupContactData {

    DeletedContacts: Contact[];
    DeletedContactsCount: number;
    NonDeletedContacts: NonDeletedIds[];
    TotalContactsCount: number;
}

export class NonDeletedIds {
    ContactId: string;
    GroupIds: string[];
}

export class TypingDataModel {
    ReceiverPhoneNumber: string;
    Action: TypeAction;
    UserID: string;
}
export class OutLookResponse {
    flag: boolean;
    totalContacts: number;
    ignoredContacts: number;
    savedContacts: number;
    existingContacts: number;
    error: string;
    loadContacts: boolean
}

export const SENT_VIA_API = {
    SENDERID: "00000000-0000-0000-0000-000000000010",
    SENT_VIA_API_TEXT: "Sent via API",
};

export enum MassActionStatus {
    DeleteGroupsStarted = "DeleteGroupsStarted",
    RefreshContactsAndGroups = "RefreshContactsAndGroups",
    MassActionStarted = "MassActionStarted",
    RefreshContacts = "RefreshContacts"
}

export enum MassActionConversationStatus {
    MassActionStarted = "MassActionStarted",
    RefreshConversations = "RefreshConversations"
}


export enum TypeAction {
    START_TYPING = "StartTyping",
    STOP_TYPING = "StopTyping",
}
export const mapToDeletedGroupContactData = (data: any): DeletedGroupContactData => {
    return {
        DeletedContacts: data.deletedContacts.map(mapToContact),
        DeletedContactsCount: data.deletedContactsCount,
        NonDeletedContacts: data.map(mapToNonDeletedIds),
        TotalContactsCount: data.totalContactsCount
    }
}

export const mapToNonDeletedIds = (data: any): NonDeletedIds => {
    return {
        ContactId: data.contactId,
        GroupIds: data.groupIds.map(x => x)
    }
}

export const mapToConverstion = (x: any): ConversationModel => {
    return {
        ID: x.id,
        SequenceId: x.sequenceId,
        PhoneNumber: !x.isOutbound && !!x.groupChat?.id ? x.groupChat?.id : x.phoneNumber,
        FromPhoneNumber: !!x.groupChat?.id ? x.contact?.phoneNumber : !!x.groupChatId ? x.phoneNumber : "",
        MaskedPhoneNumber: UtilityService.maskPhoneNumberOnLength(x.phoneNumber),
        Message: x.message,
        MessageDateTime: x.messageDateTime,
        IsPinned: x.pinned,
        IsArchived: x.archived,
        IsUnsubscribed: x.isUnSubscribed,
        IsBlocked: x.isBlocked,
        IsOutbound: x.isOutbound,
        SenderID: x.senderId || x.createdById || x.userId || "",
        UnReadCount: x.unReadCount,
        Media: x.media ? x?.media.map(mapToMediaModel) : null,
        DeliveryStatus: x.statusId as DeliveryStatus,
        IsMuted: false,
        GroupChat: x.groupChat ? { ID: x.groupChat.id, PhoneNumbers: x.groupChat.phoneNumbers, Name: x.groupChat.name, UnReadCount: x.groupChat.unReadCount } as GroupChatModel : null,
        GroupChatId: !!x.groupChatId ? x.groupChatId : !!x.groupChat ? x.groupChat.id : null,
        Campaign: x?.campaign ? { ID: x.campaign.id, ToPhoneNumbers: x.campaign.toPhoneNumbers, Name: x.campaign.name, CreatedDateTime: x.campaign.createdDateTime, CreatedById: x.campaign.createdById } as CampaignModel : null,
        CampaignId: !!x.campaignId ? x.campaignId : !!x.campaign ? x.campaign.id : null,
        ConversationAuditId: x.conversationAuditId,
        msgType: 'conversation',
        RecipientStatusList: !!x?.recipientStatusList ? x?.recipientStatusList.map(mapToRecipientStatusList) : [],
        Type: x?.type ?? 0,
        BundleId: x?.bundleId ?? "",
        IsOptInCollected: x?.isOptInCollected,
        Assignee: x.assignee,
        AssignStatus: x.assignStatus
    }
}

export const mapToMediaModel = (media): MediaModel => {
    return {
        ID: media.id,
        Name: media.name,
        ContentType: media.contentType,
        Url: `${Config.API_URL}/api/File/${media?.id}/view`
    }
}

export const mapToContact = (contact: any): Contact => {
    return {
        ID: contact.id || contact.contactId,
        Name: (contact.firstName === null && contact.lastName === null) ? '' : contact.name?.trim() ? contact.name.trim() : `${contact.firstName} ${contact.lastName ?? ""}`.trim(),
        Email: contact.email || "",
        IsUnsubscribed: contact.isUnsubscribed,
        IsBlocked: contact.isBlocked,
        PhoneNumber: contact.phoneNumber,
        CreatedDateTime: contact.createdDateTime,
        FirstName: contact.firstName !== null ? contact.firstName : '',
        LastName: contact.lastName !== null ? contact.lastName : '',
        MaskedPhoneNumber: contact.phoneNumber ? UtilityService.maskPhoneNumberOnLength(contact.phoneNumber) : "",
        Errors: contact.errors as ContactError,
        IsDeleted: !!contact.isDeleted,
        UnReadCount: contact.unReadCount,
        ContactStatus: contact.isUnsubscribed ? ContactStatus.UNSUBSCRIBED : contact.isBlocked ? ContactStatus.BLOCKED : ContactStatus.ACTIVE,
        Source: contact.source,
        AssignedToId: contact.assignedToId,
        Status: contact.status,
        CreatedById: contact.createdById,
        UpdatedById: contact.updatedById,
        IsOptInCollected: contact?.isOptInCollected,
        CustomAttributes: contact?.customAttributes ?? []
    } as Contact;
};


export const mapToContactType = (x: any): ContactType => {
    return {
        IsPinned: x.isPinned,
        IsArchived: x.isArchived,
        PhoneNumber: x.phoneNumber,
        CreatedDateTime: x.createdDateTime,
        MutedTill: x.muteDateTime
    } as ContactType;
};

export const mapToUser = (x: any): UserModel => {
    return {
        ID: x.id,
        CreatedDateTime: x.createdDateTime,
        Email: x.email,
        FirstName: x.firstName,
        ImageReferenceID: x.imageReferenceId,
        IsDeleted: x.isDeleted,
        LastLoggedIn: x.lastLoggedIn,
        LastName: x.lastName,
        OrganizationID: x.organizationId,
        Password: x.password,
        PhoneNumber: x.phoneNumber,
        PhoneNumberID: x.phoneNumberId,
        RoleID: parseInt(x.roleId),
        SeatType: !!x.seatType ? x.seatType : null,
        UserStatus: x.lastLoggedIn === null ? UserStatus.PENDING : x.isDeleted ? UserStatus.LOCKED : UserStatus.ACTIVE,
        SecondaryPhoneNumbers: x.secondaryPhoneNumbers,
        PhoneNumberGroups: x.phoneNumberGroups.map(x => ({ Id: x.id, GroupName: x.name })),
        PlanId: x.planId
    } as UserModel;
};

export const mapToGroup = (x: any): Group => {
    return {
        ID: x.id,
        Name: x.name,
        CreatedDateTime: x.createdDateTime,
        ContactsCount: x.contacts ? x.contacts.length : x.count,
        Contacts: x.contacts ? x.contacts.map(mapToContact) : [],
        IsDeleted: x.isDeleted,
        TotalActiveContacts: 0,
        TotalBlockedContacts: 0,
        TotalUnsubscribedContacts: 0,
    } as Group;
}

export const sortConversations = (cons: ConversationModel[]): ConversationModel[] => {
    return [
        ...cons.filter(x => x.IsPinned).sort((current: ConversationModel, previous: ConversationModel) => current.IsPinned && previous.IsPinned ? 0 : current.IsPinned && !previous.IsPinned ? -1 : 1),
        ...cons.filter(x => !x.IsPinned).sort((current: ConversationModel, previous: ConversationModel) => new Date(current.MessageDateTime) > new Date(previous.MessageDateTime) ? -1 : new Date(current.MessageDateTime) < new Date(previous.MessageDateTime) ? 1 : 0),
    ];
};

export const sortContacts = (contacts: Contact[]): Contact[] => {
    return [
        ...contacts.sort((current: Contact, previous: Contact) => new Date(current.CreatedDateTime) > new Date(previous.CreatedDateTime) ? -1 : new Date(current.CreatedDateTime) < new Date(previous.CreatedDateTime) ? 1 : 0),

    ];
};

export const updateContactTypesInConversations = (
    conversations: ConversationModel[],
    contactTypes: ContactType[]
): ConversationModel[] => {
    const currentTime = UtilityService.getPreferredTimeZoneTimeNow();

    const contactTypeMap = new Map(
        contactTypes.map(ct => [ct.PhoneNumber, ct])
    );

    const updatedConversations = conversations.map(conversation => {
        conversation.IsArchived = false;
        conversation.IsPinned = false;
        conversation.IsMuted = false;

        const key = conversation.GroupChat?.ID || conversation.PhoneNumber;
        const matchingContactType = contactTypeMap.get(key);

        if (matchingContactType) {
            conversation.IsArchived = matchingContactType.IsArchived;
            conversation.IsPinned = matchingContactType.IsPinned;
            conversation.IsMuted = new Date(matchingContactType.MutedTill) >= currentTime;

            if (conversation.Contact) {
                conversation.Contact.IsPinned = matchingContactType.IsPinned;
            }
        }
        return conversation;
    });

    return sortConversations(updatedConversations);
};

// export const updateContactsInConversations = (
//     conversations: ConversationModel[],
//     contacts: Contact[]
// ): ConversationModel[] => {
//     const contactMap = new Map(
//         contacts.map(contact => [UtilityService.unmaskPhoneNumber(contact.PhoneNumber), contact])
//     );
//     conversations.forEach(con => {
//         const unmaskedPhoneNumber = UtilityService.unmaskPhoneNumber(con.PhoneNumber);
//         const matchingContact = contactMap.get(unmaskedPhoneNumber);
//         if (matchingContact) {
//             con.Contact = matchingContact;
//             con.IsBlocked = matchingContact.IsBlocked;
//             con.IsUnsubscribed = matchingContact.IsUnsubscribed;
//             con.UnReadCount = matchingContact.UnReadCount;
//         }
//     });

//     return sortConversations(conversations);
// };
export const updateContactsInConversations = (
    conversations: ConversationModel[],
    contacts: Contact[]
): ConversationModel[] => {
    const contactMap = new Map(
        contacts.map(contact => [
            UtilityService.unmaskPhoneNumber(contact.PhoneNumber),
            contact
        ])
    );

    const updatedConversations = conversations.map(conversation => {
        const unmaskedPhoneNumber = UtilityService.unmaskPhoneNumber(conversation.PhoneNumber);
        const matchingContact = contactMap.get(unmaskedPhoneNumber);

        if (matchingContact) {
            return {
                ...conversation,
                Contact: matchingContact,
                IsBlocked: matchingContact.IsBlocked,
                IsUnsubscribed: matchingContact.IsUnsubscribed,
                UnReadCount: matchingContact.UnReadCount,
            };
        }
        return conversation;
    });

    return sortConversations(updatedConversations);
};

export const pushConversation = (conversations: ConversationModel[], contacts: Contact[], newCons: ConversationModel[]): ConversationModel[] => {
    const conversationMap = new Map<string, ConversationModel>();
    const contactMap = new Map<string, Contact>();

    conversations.forEach(con => {
        conversationMap.set(getConversationKey(con), con);
    });

    contacts.forEach(contact => {
        contactMap.set(UtilityService.unmaskPhoneNumber(contact.PhoneNumber), contact);
    });

    const updatedConversations = conversations.slice();

    newCons.forEach(newConRaw => {
        const newCon: ConversationModel = { ...newConRaw };
        const oldCon = conversationMap.get(getConversationKey(newCon));
        if (newCon.Type === Type.TeamNote) {
            return
        }
        if (oldCon) {
            newCon.IsPinned = oldCon.IsPinned;
            newCon.IsMuted = oldCon.IsMuted;
            newCon.IsBlocked = oldCon.IsBlocked;
            newCon.Contact = oldCon.Contact;
            newCon.IsArchived = oldCon.IsArchived;
            if (newCon.Type === Type.AssignStatus) {
                newCon.Message = oldCon.Message;
                newCon.Media = oldCon.Media;
                newCon.MessageDateTime = oldCon.MessageDateTime;
            }
            if (newCon.Type !== Type.AssignStatus) {
                newCon.AssignStatus = oldCon.AssignStatus;
                newCon.Assignee = oldCon.Assignee;
            }
        } else {
            newCon.Contact = contactMap.get(UtilityService.unmaskPhoneNumber(newCon.PhoneNumber));
        }

        const index = updatedConversations.findIndex(x => getConversationKey(x) === getConversationKey(newCon));
        if (index !== -1) {
            updatedConversations.splice(index, 1);
        }
        updatedConversations.push(newCon);
    });

    return sortConversations(updatedConversations);
};

const getConversationKey = (con: ConversationModel): string => {
    if (con.Campaign?.ID) return `campaign:${con.Campaign.ID}`;
    if (con.GroupChat?.ID) return `groupchat:${con.GroupChat.ID}`;
    return `phone:${UtilityService.unmaskPhoneNumber(con.PhoneNumber)}`;
};

export const pushConversationInContact = (contacts: Contact[], newCons: ConversationModel[]): Contact[] => {
    let cons = [...contacts]
    newCons.forEach(newCon => {
        let contact = contacts.find(x => UtilityService.unmaskPhoneNumber(x.PhoneNumber) === UtilityService.unmaskPhoneNumber(newCon.PhoneNumber));
        if (contact) {
            contact.IsPinned = newCon.IsPinned;
            contact.IsUnsubscribed = newCon.IsUnsubscribed;
        }
        cons = [...contacts]
    })

    return sortContacts(cons);
}


export const pushHistory = (history: { [key: string]: ConversationModel[] }, newCons: ConversationModel[]): { [key: string]: ConversationModel[] } => {
    newCons.forEach(newCon => {
        let historyToUpdate = history[!!newCon.Campaign?.ID ? newCon.Campaign?.ID : !!newCon.GroupChat?.ID ? newCon.GroupChat?.ID : newCon.PhoneNumber.replace("+", '')];
        if (historyToUpdate && historyToUpdate.length) {
            historyToUpdate = historyToUpdate.filter(x => x.SequenceId != newCon.SequenceId)
            historyToUpdate?.push(newCon)
            history[!!newCon.Campaign?.ID ? newCon.Campaign?.ID : !!newCon.GroupChat?.ID ? newCon.GroupChat?.ID : newCon.PhoneNumber.replace("+", '')] = historyToUpdate;
        }
        // else {
        //     if (newCon.IsOutbound) {
        //         history[!!newCon.GroupChat?.ID ? newCon.GroupChat?.ID : newCon.PhoneNumber.replace("+", '')] = newCons
        //     }
        // }

        newCon.Campaign?.ToPhoneNumbers.map(x => {
            let newConversation = { ...newCon };
            let historyToUpdate = history[x.replace("+", '')];
            if (historyToUpdate && historyToUpdate.length && !historyToUpdate[0].IsUnsubscribed) {
                newConversation.CampaignId = newCon?.Campaign?.ID;
                newConversation.PhoneNumber = x?.replace("+", '');
                newConversation.Campaign = null;
                historyToUpdate = historyToUpdate?.filter(x => (x.ID !== newCon.ID) && x.ID)
                historyToUpdate?.push(newConversation);
                history[x?.replace("+", '')] = historyToUpdate;
            }
        })
    })
    return { ...history };
}

export const handlePushContacts = (state: AppState, action): AppState => {
    // function not using
    let { Conversations, Contacts } = state;
    action.payload.forEach((contact: Contact) => {
        let _conversation = Conversations.find(x => x.PhoneNumber === contact.PhoneNumber || x.Contact?.ID === contact.ID);
        let _contact = Contacts.find(x => x.ID === contact.ID);
        if (_conversation) {
            _conversation.UnReadCount = contact.UnReadCount;
            _conversation.IsBlocked = contact.IsDeleted ? _conversation.IsBlocked : contact.IsBlocked;
        }

        if (_conversation?.Contact?.ID === contact.ID && (contact.IsDeleted || contact.MaskedPhoneNumber !== _conversation?.Contact?.MaskedPhoneNumber)) {
            _conversation.Contact = undefined;
        }

        if (_contact) {
            if (_contact.IsBlocked !== contact.IsBlocked) {
                _contact.IsBlocked = contact.IsBlocked;
                _contact.CreatedDateTime = contact.CreatedDateTime;
            }
            _contact.UnReadCount = contact.UnReadCount;
            _contact.IsDeleted = contact.IsDeleted;
        }
    });

    Contacts = Contacts.map(con => ({
        ...con,
        ...action.payload.find(payload => (payload.ID === con.ID))
    }))

    Contacts = Contacts.filter(e => (!e.IsDeleted))

    // AllContacts = AllContacts.map(con => ({
    //     ...con,
    //     ...action.payload.find(payload => payload.ID === con.ID)
    // }))

    Contacts = [...Contacts, ...action.payload.filter(x => !Contacts.map(y => y.ID).includes(x.ID))]
    // AllContacts = [...AllContacts, ...action.payload.filter(x => !AllContacts.map(y => y.ID).includes(x.ID))]

    return {
        ...state,
        Conversations: [...Conversations],
        Contacts: sortContacts([...Contacts]),
        // AllContacts: sortContacts([...AllContacts]),
        Groups: updateContactsInGroup(state.Groups, Contacts),
        Settings: {
            ...state.Settings,
            // BlockedContacts: Contacts.filter((x: Contact) => x.IsBlocked),
            // UnSubscribedContacts: Contacts.filter((x: Contact) => x.IsUnsubscribed)
        }
    };
}


// export const updateContactsInGroup = (groups: Group[], contacts: Contact[]): Group[] => {
//     if (contacts.length) {
//         groups.forEach(x => {
//             let newContacts = [...contacts.filter(y => x.Contacts?.map(z => z.ID).includes(y.ID))];
//             let oldContacts = x.Contacts?.filter(y => !newContacts.map(z => z.ID).includes(y.ID))
//             x.Contacts = newContacts.concat(oldContacts);
//             x.TotalActiveContacts = newContacts.filter(y => (!y.IsBlocked && !y.IsUnsubscribed)).length;
//             x.TotalBlockedContacts = newContacts.filter(y => y.IsBlocked).length;
//             x.TotalUnsubscribedContacts = newContacts.filter(y => y.IsUnsubscribed).length;
//             x.ContactsCount = newContacts.length
//         })
//     }
//     return [...groups];
// }


export const updateContactsInGroup = (groups: Group[], contacts: Contact[]): Group[] => {
    if (!contacts.length) return [...groups];

    // Create a Map for O(1) lookups instead of O(n) includes
    const contactsMap = new Map(contacts.map(contact => [contact.ID, contact]));

    return groups.map(group => {

        if (!group.Contacts?.length) return group;

        const newContacts: Contact[] = [];
        const oldContacts: Contact[] = [];

        // Single pass to separate contacts and calculate counts
        let activeCount = 0;
        let blockedCount = 0;
        let unsubscribedCount = 0;

        group.Contacts.forEach(contact => {
            const updatedContact = contactsMap.get(contact.ID);

            if (updatedContact) {
                newContacts.push(updatedContact);

                // Calculate counts in the same pass
                if (!updatedContact.IsBlocked && !updatedContact.IsUnsubscribed) {
                    activeCount++;
                } else if (updatedContact.IsBlocked) {
                    blockedCount++;
                } else if (updatedContact.IsUnsubscribed) {
                    unsubscribedCount++;
                }
            } else {
                oldContacts.push(contact);
            }
        });
        return {
            ...group,
            Contacts: [...newContacts, ...oldContacts],
            TotalActiveContacts: activeCount,
            TotalBlockedContacts: blockedCount,
            TotalUnsubscribedContacts: unsubscribedCount,
            ContactsCount: newContacts.length
        };
    });
};

// export const updateGroupsInContacts = (contacts: Contact[], groups: Group[]): Contact[] => {
//     const groupIds = new Set(groups.map(g => g.ID));

//     return contacts.map(contact => {
//         const preservedGroups = (contact.Groups || []).filter(g => !groupIds.has(g.ID));

//         const matchingGroups = groups.filter(group =>
//             group.Contacts?.some(c => c.ID === contact.ID)
//         );

//         return {
//             ...contact,
//             Groups: [...preservedGroups, ...matchingGroups],
//         };
//     });
// };

export const updateGroupsInContacts = (contacts: Contact[], groups: Group[]): Contact[] => {
    const groupIds = new Set(groups.map(g => g.ID));

    const contactToGroupsMap = new Map<string, Group[]>();

    for (const group of groups) {
        if (group.Contacts?.length) {
            for (const contact of group.Contacts) {
                if (!contactToGroupsMap.has(contact.ID)) {
                    contactToGroupsMap.set(contact.ID, []);
                }
                contactToGroupsMap.get(contact.ID)!.push(group);
            }
        }
    }

    return contacts.map(contact => {
        const preservedGroups = contact.Groups?.filter(g => !groupIds.has(g.ID)) || [];
        const matchingGroups = contactToGroupsMap.get(contact.ID) || [];
        return {
            ...contact,
            Groups: preservedGroups.concat(matchingGroups),
        };
    });
};


export const handlePushGroupChat = (state: AppState, action): AppState => {
    let { Conversations } = state;

    action.payload.map((x) => {
        let con = Conversations.find(y => y.GroupChat?.ID === x.id)
        if (con) {
            con.GroupChat.UnReadCount = x.unReadCount;
        }
    })
    return {
        ...state, Conversations: [...Conversations]
    }
}

export const PushGroupChatName = (state: AppState, id, name): AppState => {

    let { Conversations } = state;

    let con = Conversations.find(y => y.GroupChat?.ID === id)
    if (con) {
        con.GroupChat.Name = name;
    }
    return {
        ...state, Conversations: [...Conversations]
    }
}


// Convesation Tabs

export class ConversationTabsModel {
    constructor() {
    }

    id: number;
    label: any
    value: string;
    isLoading: boolean;
    data: ConversationCardModel[] | null;
    hide?: boolean;
    emptyMessage: string;
}

export interface IConversationCardFlags {
    IsActive: boolean;
    // Index: number;
    // OptionsRef: Element | ((element: Element) => Element) | null | undefined;
}

export type ConversationCardModel = IConversationCardFlags & ConversationModel;

// export type ConversationCardModel = ConversationModel


export class ImportContactsReportResponse {
    constructor() {
    }
    Id: string;
    IsDeleted: boolean;
    CreatedDateTime: string;
    CreatedById: string;
    CreatedBy: string;
    Source: string;
    FileName: string;
    SavedContacts: number;
    ExistingContacts: number;
    IgnoredContacts: number;
    ClioHubspotAddedContacts: number;
}


export const handleNewSecureChatMessages = (ExcistingHistory: ConversationModel[], NewMessages: ConversationModel[]): ConversationModel[] => {

    let NewMessageIds = NewMessages.map(x => x.ID)

    let updatedHistory = ExcistingHistory.filter(x => !NewMessageIds.includes(x.ID))

    return [...updatedHistory, ...NewMessages].sort((a, b) => new Date(a.MessageDateTime)?.getTime() - new Date(b.MessageDateTime)?.getTime())

}

export const maptoImportContactsReportResponse = (x: any): ImportReportResponse => {
    return {
        Id: x.id,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime,
        CreatedById: x.createdById,
        CreatedBy: x.createdBy,
        Source: x.source,
        FileName: x.fileName,
        SavedRecords: x.savedContacts,
        ExistingRecords: x.existingContacts,
        IgnoredRecords: x.ignoredContacts,
        ClioHubspotAddedRecords: x.clioHubspotAddedContacts,
        Status: x.status
    } as ImportReportResponse;
}


export const mapSecureChatHistoryToConversationModel = (x: any) => {
    return {
        ID: x.m_id === "secure_chat_welcome_message" ? x.m_id : x.id,
        PhoneNumber: x.mp_number,
        FromPhoneNumber: x.senderId,
        Message: x.content.find(x => x.type === "text") ? x.content.find(x => x.type === "text").value : "",
        MessageDateTime: x.delivered_at,
        IsOutbound: !x.inbound,
        SenderID: x.senderId,
        Media: x.content.filter(x => x.type !== "text").map(x => ({
            ID: "", Url: x.value, Name: x?.file_name, ContentType: x.type
        })),
        DeliveryStatus: x.status,
        IsMuted: false,
    } as ConversationModel
}

export const mapSecureChatParticipantToConversationCardModel = (data: any) => {
    let Contacts = store.getState().Contacts;
    let contact = Contacts.find(x => x.PhoneNumber === data.phone_number)
    return {
        ID: data.m_id === "secure_chat_welcome_message" ? data.m_id : data.id,
        PhoneNumber: data.phone_number,
        FromPhoneNumber: data.falkon_number,
        Message: !!data.messages && data.messages[0]?.content[0]?.type === "text" ? data.messages[0]?.content[0]?.value : "",
        MessageDateTime: (!!data.messages && data.messages[0]?.delivered_at),
        IsOutbound: data.inbound,
        SenderID: data.falkon_number,
        Media: !!data.messages && data.messages[0]?.content[0]?.type !== "text" ? data.messages[0]?.content.map(x => ({
            ID: "", Url: x.value, Name: x?.file_name, ContentType: x.type
        })) : "",
        DeliveryStatus: (!!data.messages && data.messages[0]?.status),
        IsMuted: false,
        UnReadCount: data.unread_count,
        Contact: !!contact ? contact : null,
        msgType: 'secure-chat',
        IsArchived: data.is_archived
    } as ConversationCardModel
}

export const mapSecureChatSchedulesToConversationMessage = (x: any) => {

    return {
        ID: x.id,
        PhoneNumber: x.mp_number,
        FromPhoneNumber: x.senderId,
        Message: x.content.find(x => x.type === "text") ? x.content.find(x => x.type === "text").value : "",
        MessageDateTime: x.next_send_time,
        IsOutbound: true,
        SenderID: x.senderId,
        Media: x.content.filter(x => x.type !== "text").map(x => ({
            ID: "", Url: x.value, Name: x?.file_name, ContentType: x.type
        })),
        DeliveryStatus: 5,
        IsMuted: false,
        ScheduleIcon: true,
        ScheduleType: x.schedule_type,
        IsActive: false,
        IsArchived: false,
        MaskedPhoneNumber: x.mp_number,
        UnReadCount: 0,
        IsPinned: false,
        IsBlocked: false,
        IsUnsubscribed: false,
        Status: x.status,
        Type: Type.Normal
    } as ConversationCardModel

}







export interface ContactHistory {
    Id: string;
    PhoneNumber: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Errors: {
        AdditionalProp1: string;
        AdditionalProp2: string;
        AdditionalProp3: string;
    };
}

export class SingleImportContactsResponse {
    constructor() {
    }
    Id: string;
    IsDeleted: boolean;
    CreatedDateTime: string;
    CreatedById: string;
    CreatedBy: string;
    Source: string;
    FileName: string;
    SavedRecords: ContactHistory[];
    ExistingRecords?: ContactHistory[];
    IgnoredRecords: ContactHistory[];
    ClioAddedRecords: ContactHistory[];
}

export const SingleMaptoImportContactsReportResponse = (x: any): SingleImportContactsResponse => {
    return {
        Id: x.id,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime,
        CreatedById: x.createdById,
        CreatedBy: x.createdBy,
        Source: x.source,
        FileName: x.fileName,
        SavedRecords: Array.isArray(x.savedContacts) ? x.savedContacts.map(maptoReport) : [],
        ExistingRecords: Array.isArray(x.existingContacts) ? x.existingContacts.map(maptoReport) : [],
        IgnoredRecords: Array.isArray(x.ignoredContacts) ? x.ignoredContacts.map(maptoReport) : [],
        ClioAddedRecords: Array.isArray(x.clioAddedContacts) ? x.clioAddedContacts.map(maptoReport) : [],
    } as SingleImportContactsResponse;
}

export const maptoReport = (x: any): ContactHistory => {
    return {
        Id: x.id,
        PhoneNumber: x.phoneNumber,
        FirstName: x.firstName,
        LastName: x.lastName,
        Email: x.email,
        Errors: x.errors
    } as ContactHistory;
}

export enum StatusEnum {
    Open = 0,
    InProgress = 1,
    Resolved = 2,
    Closed = 3,
    FollowUp = 4
}
export interface ContactStatusHistory {
    AssignedDateTime: string;
    AssignedToId: string;
    ContactNumber: string;
    CreatedById: string;
    MessageDateTime: string;
    PhoneNumberId: string;
    Status: string;
    // assignAndStatus: boolean;
    msgType: string
    IsStatusChange: boolean
}

export const mapToContactstatusHistory = (x: any): ContactStatusHistory => {
    return {
        AssignedDateTime: x.assignedDateTime,
        AssignedToId: x.assignedToId,
        ContactNumber: x.contactNumber,
        CreatedById: x.createdById,
        MessageDateTime: x.createdDateTime,
        PhoneNumberId: x.phoneNumberId,
        Status: x.status,
        assignAndStatus: true,
        msgType: 'ticket',
        IsStatusChange: x.isStatusChange
    } as ContactStatusHistory;
}
export const sortContactStatusHistory = (cons: ContactStatusHistory[]): ContactStatusHistory[] => {
    return [
        ...cons.sort((current: ContactStatusHistory, previous: ContactStatusHistory) => new Date(current.MessageDateTime) > new Date(previous.MessageDateTime) ? -1 : new Date(current.MessageDateTime) < new Date(previous.MessageDateTime) ? 1 : 0),
    ];
};

export const mapToRecipientStatusList = (x) => {
    return {
        PhoneNumber: x.phoneNumber,
        Status: x.statusId
    }
}

export type CombinedInterface = ConversationModel | ContactStatusHistory

export interface ConversationAssignStatus {
    Assignee: string,
    Status: StatusEnum,
    ContactNumber: string
}

export const mapToConversationAssignStatus = (x: any): ConversationAssignStatus => {
    return {
        Assignee: x.assignee,
        Status: x.status,
        ContactNumber: x.contactNumber?.replace("+", "")
    } as ConversationAssignStatus;
}
